import { FC } from 'react';

interface SimpleCardProps {
    title?: string;
}

export const SimpleCard: FC<SimpleCardProps> = (props) => {
    const { title, children } = props;
    return <div className='vb-w-100 vb-h-75 vb-d-flex vb-justify-content-center vb-flex-column vb-px-3'>
        <div className='vb-fw-bold vb-fs-5 vb-mb-4 vb-text-center'>{title}</div>
        <div className='vb-mb-4 vb-mx-auto'>
            {children}
        </div>
    </div>;
};
